import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';

Vue.use(VueRouter);

export default new VueRouter({
    mode    : 'history',
    base    : 'app',
    routes  : routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x : 0,
                y : 0
            };
        }
    }
});
